import {apiConstants} from "../apiConstants";
import type {RequestType} from "./requestTypes";

export type AjaxCallback = (...args: unknown[]) => void;

export interface AjaxRequestOptions {
	url: string;
	type: RequestType;
	data?: unknown;
	contentType?: string;
	dataType?: string | null;
	enctype?: string | null;
	responseType?: string | null;
	xhrFields?: Record<string, unknown>;
	processData?: boolean | null;
	cache?: boolean;
	headers?: Record<string, string>;
	successMessage?: string | null;
	successCallback?: ((data: unknown, resolve: (value: unknown) => void, notificationFactory: unknown) => void) | null;
	errorCallback?: ((error: unknown, reject: (reason?: unknown) => void, notificationFactory: unknown) => void) | null;
	setCallbacks: (successCallback: AjaxCallback, errorCallback?: AjaxCallback | null) => void;
	notifyOnError: boolean;
}

export const ajaxRequestOptions = (url: string, type: RequestType, data?: unknown, successMessage?: string, contentType?: string): AjaxRequestOptions => {
	const options = {
		url: url,
		type: type,
		data: data,
		contentType: contentType ? contentType : apiConstants.contentType.JSON,
		dataType: null as string | null,
		enctype: null as string | null,
		responseType: null as string | null,
		xhrFields: {} as Record<string, unknown>,
		processData: null as boolean | null,
		cache: false,
		_successMessage: null as string | null,
		_successCallback: null as AjaxCallback | null,
		_errorCallback: null as AjaxCallback | null,
		get successMessage(): string | null {
			return this._successMessage;
		},
		set successMessage(message: string) {
			this._successMessage = message;
			this._successCallback = null;
		},
		get successCallback(): AjaxCallback | null {
			return this._successCallback;
		},
		setCallbacks(successCallback: AjaxCallback, errorCallback: AjaxCallback | null = null) {
			if (isFunction(successCallback)) {
				this._successMessage = null;
				this._successCallback = successCallback;
			}
			if(isFunction(errorCallback))
				this._errorCallback = errorCallback;
		},
		get errorCallback(): AjaxCallback | null {
			return this._errorCallback;
		},
		notifyOnError: true,
	};

	if (successMessage) options.successMessage = successMessage;

	return options as AjaxRequestOptions;

	function isFunction(obj: unknown): obj is (...args: unknown[]) => unknown {
		return typeof obj === "function";
	}
};
